import { render, staticRenderFns } from "./tile-selection.vue?vue&type=template&id=6afbcbd6&"
import script from "./tile-selection.vue?vue&type=script&lang=js&"
export * from "./tile-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afbcbd6')) {
      api.createRecord('6afbcbd6', component.options)
    } else {
      api.reload('6afbcbd6', component.options)
    }
    module.hot.accept("./tile-selection.vue?vue&type=template&id=6afbcbd6&", function () {
      api.rerender('6afbcbd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/templates/tile-selection.vue"
export default component.exports